import { Menu, Modal, UnstyledButton } from '@mantine/core';
import { useState } from 'react';

import { Batch, BatchTypeEnum, EnvironmentCountries } from '@e-origin/shared';

import { actionsIcon, IconFactory } from '@assets';
import { useSettings } from '@hooks/useSettings';
import { isUtbReportAvailable } from '../UTBReport';
import { BulkArchiveBatchesModal } from './BulkArchiveBatchesModal';
import { GenerateBulkCustomsReportModal } from './GenerateBulkCustomsReportModal';
import { GenerateBulkUtbReportModal } from './GenerateBulkUtbReportModal';

export interface BulkActionsMenuProps {
  selectedBatchIds: string[];
  batchesData: Batch[];
  batchView: BatchTypeEnum;
  onBulkActionDone?: () => void;
}

type OpenModal = 'customs' | 'utb' | 'archive' | null;

export const BulkActionsMenu: React.FC<BulkActionsMenuProps> = ({ selectedBatchIds, batchesData, batchView, onBulkActionDone }) => {
  const { data: settings } = useSettings();
  const [openModal, setOpenModal] = useState<OpenModal>(null);

  const selectedBatches = batchesData.filter((batch) => selectedBatchIds.includes(batch._id));
  const hasUtbEligible = selectedBatches.some((batch) => isUtbReportAvailable(batch, settings));
  const utbLabel = settings.country === EnvironmentCountries.NL ? 'Generate UTB reports' : 'Generate Customs Debt reports';

  const closeModal = () => setOpenModal(null);

  return (
    <>
      <Modal opened={openModal === 'customs'} onClose={closeModal} title="Bulk Customs Reports" centered>
        <GenerateBulkCustomsReportModal selectedBatchIds={selectedBatchIds} batchesData={batchesData} batchView={batchView} onClose={closeModal} />
      </Modal>

      <Modal opened={openModal === 'utb'} onClose={closeModal} title={utbLabel} centered>
        <GenerateBulkUtbReportModal selectedBatchIds={selectedBatchIds} batchesData={batchesData} onClose={closeModal} />
      </Modal>

      <Modal opened={openModal === 'archive'} onClose={closeModal} title="Bulk Archive Batches" centered>
        <BulkArchiveBatchesModal selectedBatchIds={selectedBatchIds} onClose={closeModal} onBulkActionDone={onBulkActionDone} />
      </Modal>

      <Menu position="left-start">
        <Menu.Target>
          <UnstyledButton pr="xs">
            <img src={actionsIcon} alt="bulk actions" />
          </UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item leftSection={<img src={IconFactory.report} alt="report" style={{ maxWidth: 22 }} />} onClick={() => setOpenModal('customs')}>
            Generate Bulk Customs Reports
          </Menu.Item>
          {hasUtbEligible && (
            <Menu.Item leftSection={<img src={IconFactory.report} alt="report" style={{ maxWidth: 22 }} />} onClick={() => setOpenModal('utb')}>
              {utbLabel}
            </Menu.Item>
          )}
          <Menu.Item leftSection={<img src={IconFactory.archive} alt="archive" style={{ maxWidth: 22 }} />} onClick={() => setOpenModal('archive')}>
            Bulk Archive Batches
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </>
  );
};
